import { Form } from 'antd';
import { breakpoints } from 'config/config';
import styled from 'styled-components';
import { Drawer } from 'ui';
import { CouponFormValues } from './CouponCreateUpdateDrawer';

export const StyledForm = styled(Form<CouponFormValues>)`
  .description {
    font-size: 14px;
    color: ${(props) => props.theme.descriptionText};
    margin: -20px 0 20px 0;
  }

  .label {
    font-size: 14px;
    color: ${(props) => props.theme.colorPrimary};
  }

  .ant-picker-range {
    width: 100%;
  }

  .discount-select .ant-form-item {
    margin-bottom: 0;
  }

  .discount-select .ant-space-compact > .ant-form-item {
    width: 60%;
  }

  .discount-select .ant-space-compact > .ant-form-item:nth-child(2) {
    width: 40%;
  }

  .discount-select .ant-space-compact {
    width: 100%;
  }

  .discount-select .ant-input-number {
    width: 100%;
  }

  .discount-select .ant-select {
    width: 100%;
  }

  .discount-select .ant-select-selector {
    background: ${(props) => props.theme.inputAddonBg};
  }
`;

export const StyledCouponCreateUpdateDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    .ant-drawer-close {
      margin-inline-end: 0;
      color: ${(props) => props.theme.black};
    }
  }
  .ant-drawer-footer {
    .footer {
      display: flex;
      align-items: center;
      gap: 20px;
      justify-content: flex-end;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-drawer-header {
      min-height: fit-content !important;
      padding: 16px;
      .ant-drawer-title {
        font-size: 1rem;
      }
    }

    .ant-drawer-body {
      padding: 16px;

      .ant-form-item {
        margin-bottom: 10px;

        .ant-input {
          border-radius: 3px;
        }

        .ant-select {
          border-radius: 3px;
        }

        .ant-select-selector {
          border-radius: 3px;
        }

        .ant-picker {
          border-radius: 3px;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .ant-drawer-body {
      .ant-picker-panels {
        flex-direction: column;
      }
    }
  }
`;

export const StyledCouponsPage = styled('div')`
  height: 100%;
  @media only screen and (max-width: ${breakpoints.lg}px) {
    .hide-mobile {
      display: none;
    }
    .ant-tabs-nav::before {
      display: none;
    }
    .ant-tabs-nav {
      margin: 16px 0 16px 0;
      .ant-tabs-nav-wrap {
        display: none;
      }
    }
  }
`;
